import React, { useId } from 'react';
import { Box } from '@mui/material';
import { Locale } from '../i18n';

/** Flat SVG flags: Windows Chrome does not render emoji flags, so draw them. */
const FlagIcon: React.FC<{ locale: Locale; size?: number }> = ({ locale, size = 22 }) => {
  const clipId = useId();
  const frame = {
    width: size,
    height: size * 0.6,
    borderRadius: '2px',
    overflow: 'hidden',
    flexShrink: 0,
    boxShadow: '0 0 0 1px rgba(0,0,0,0.25)',
    display: 'block',
  } as const;

  if (locale === 'de') {
    return (
      <Box component="svg" viewBox="0 0 60 36" sx={frame} aria-hidden>
        <rect width="60" height="12" y="0" fill="#000000" />
        <rect width="60" height="12" y="12" fill="#DD0000" />
        <rect width="60" height="12" y="24" fill="#FFCE00" />
      </Box>
    );
  }

  return (
    <Box component="svg" viewBox="0 0 60 36" sx={frame} aria-hidden>
      <clipPath id={clipId}>
        <path d="M30,18 h30 v18 z v18 h-30 z h-30 v-18 z v-18 h30 z" />
      </clipPath>
      <rect width="60" height="36" fill="#012169" />
      <path d="M0,0 L60,36 M60,0 L0,36" stroke="#FFFFFF" strokeWidth="7" />
      <path d="M0,0 L60,36 M60,0 L0,36" clipPath={`url(#${clipId})`} stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v36 M0,18 h60" stroke="#FFFFFF" strokeWidth="12" />
      <path d="M30,0 v36 M0,18 h60" stroke="#C8102E" strokeWidth="7" />
    </Box>
  );
};

export default FlagIcon;
